import MembershipRole from './MembershipRole';
import User from './User';

class Membership {
  public readonly id: string;
  public readonly user: User;
  public readonly membershipRoles: MembershipRole[];
  constructor({ id, user, membershipRoles }: { id: string; user: User; membershipRoles: MembershipRole[] }) {
    this.id = id;
    this.user = user;
    this.membershipRoles = membershipRoles;
  }

  public static fromJSON = (value: any) => {
    const { id, user, membershipRoleAssignments } = Object.assign({}, value);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');

    return new Membership({
      id,
      user: User.fromJSON(user),
      membershipRoles: membershipRoleAssignments.map((m: any) => MembershipRole.fromJSON(m)),
    });
  };
}

export default Membership;
